import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "thera-header-action-button",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./header-action-button.component.html",
  styleUrls: ["./header-action-button.component.scss"],
})
export class TheraHeaderActionButtonComponent {
  @Input() disabled = false;

  @Output() clicked = new EventEmitter<MouseEvent>();

  onButtonClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.clicked.emit(event);
  }
}
